import React, { Component } from 'react';
import { getAccInfo, closeCardFree } from './service'
import { Toast, Form, Button, Dialog, Space, SpinLoading, Card, Modal } from 'antd-mobile'
import { debounce } from '../../utils/util'
import './index.scss';
import wx from 'weixin-js-sdk';

var browser = {
  versions: function () {
    var u = navigator.userAgent;
    return {
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
    };
  }(),
}

class closeCardPasswordFreePay extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalVisible: false,
      projectId: null,
      userInformation: [],
      userId: null,
      telPhone: null,
      loginCode: null,
      accountId: null,
      isLoading: true,
      showModal: false,
    }
    this.onSubmit = debounce(this.onSubmit, 1000)

  }
  componentDidMount() {
    document.title = "关闭一卡通免密支付"
    let search = window.location.search.slice(1)
    let params = search.split('&')
    var theRequest = new Object()
    for (let i = 0; i < params.length; i++) {
      theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
    }
    this.setState({
      projectId: theRequest.projectId,
      telPhone: theRequest.telPhone,
      userId: theRequest.userId,
      loginCode: theRequest.loginCode,
      accountId: theRequest.accountId,
    }, () => {
      this.getAccountInfo()
    })
  }
  getAccountInfo = () => {
    let { userId, projectId, telPhone, loginCode, accountId, } = this.state
    let params = {
      projectId: projectId,
      telPhone: telPhone,
      userId: userId,
      loginCode: loginCode,
      accountId: accountId
    }
    getAccInfo(params).then(res => {
      if (res.errorCode == 0) {
        this.setState({
          userInformation: res.data,
          isLoading: false
        })
      } else {
        Toast.show({
          content: res.errorMessage,
          position: 'bottom',
        })
        this.setState({
          isLoading: false
        })
      }
    })
  }

  // 返回app
  onBackApp = () => {
    var userAgent = navigator.userAgent;
    const OpenHarmony = /(OpenHarmony).*?/.test(userAgent);
    const ua = userAgent.toLowerCase();
    const isWeChat = /micromessenger/.test(ua);
    if (isWeChat) {
      // 在微信中，尝试使用小程序接口
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          wx.miniProgram.navigateBack({
            delta: 1
          })
        }
      })
    }
    if (browser.versions.android || OpenHarmony) {
      window.android.onCampusPayExit();
      return;
    }
    if (browser.versions.ios) {
      window.webkit.messageHandlers.onCampusPayExit.postMessage('');
      return;
    }
  }

  showConfirm = () => {
    this.setState({ showModal: true });
  }
  /**
    * 关闭
    */
  onSubmit = async () => {
    let { userId, projectId, telPhone, loginCode, accountId, } = this.state
    let params = {
      userId,
      projectId,
      loginCode,
      telPhone,
      accountId
    }
    closeCardFree(params).then(res => {
      if (res.errorCode == 0) {
        Toast.show({
          content: '关闭成功！',
          position: 'bottom',
        })
        setTimeout(() => {
          this.onBackApp()
        }, 100);
      } else {
        Toast.show({
          content: res.errorMessage,
          position: 'bottom',
        })
      }
    })
    return true
  }

  onCancel = () => {
    this.setState({ showModal: false });
  }
  renderModal = () => {
    const { showModal } = this.state;
    return (
      <>
        {/* 底部透明灰色层  */}
        <div className={showModal ? "mask display2" : "mask"}></div>
        {/* <!-- 提示层 --> */}
        <div className={showModal ? "board-closePay board display" : "board-closePay board"}>
          <div className="close-modal">
            <img className="img-warn" src={require('../../assets/icon-close-warn.png')} alt="" />
            <div className="title">关闭免密支付</div>
            <div className='text'>
              <text className="t_value_center">确认关闭一卡通免密支付？</text>
            </div>
            <div className="modal-btn-box">
              <span className="close-cancel" onClick={this.onCancel}>取消</span>
              <span className="close-submit" onClick={this.onSubmit}>确定</span>
            </div>
          </div>
        </div>
      </>
    )
  }

  render() {
    const { userInformation } = this.state
    return (
      <>
        {this.renderModal()}
        {!this.state.isLoading ? <div className="card-password-free-pay-page">
          <Form layout='horizontal'
            onFinish={this.showConfirm}
            footer={
              <Button style={{ background: 'linear-gradient( 270deg, #FF5A5A 0%, #FF8888 100%)' }} block color='primary' type='submit' size='large'>立即关闭</Button>
            }
          >
            <Card title='一卡通信息'>
              <div style={{ fontSize: '13px', marginTop: '12px' }}><span style={{ color: '#999999' }}>学号：</span>{userInformation.studentNumber}</div>
              <div style={{ fontSize: '13px', marginTop: '20px' }}><span style={{ color: '#999999' }}>姓名：</span>{userInformation.studentName}</div>
              <div style={{ fontSize: '13px', marginTop: '20px' }}><span style={{ color: '#999999' }}>余额：</span>{userInformation.amount != null ? userInformation.amount + '元' : ''}</div>
              <div style={{ fontSize: '13px', marginTop: '20px' }}><span style={{ color: '#999999' }}>状态：</span>{userInformation.signStatus == 1 ? '已签约' : '未签约'}</div>
            </Card>
          </Form>
        </div>
          :
          <div className="pay-page-loading">
            <Space direction='horizontal' wrap block style={{ '--gap': '16px' }}>
              <SpinLoading color='primary' />
            </Space>
          </div>
        }
      </>
    );
  }

}

export default closeCardPasswordFreePay;